import { FC, useEffect, useState } from "react";
import {
  QuickSearchIcon,
  SearchPlaceholderWrapper,
  HeaderText,
  Wrapper,
  InputContainer,
  TableWrapper,
  ApplicantStatusContainer,
  ApplicantStatusIn,
  ApplicantStatus,
  LoaderContainer,
  NameWrapper,
  StarIcon,
} from "./elements";
import { search, noResults, star } from "../../../assets/icons/index";
import { TextInput } from "../../atoms/TextInput";
import { Table } from "../../organisms/Table";
import { Loader } from "../../atoms/Loader";

type Props = {
  applicants: any[];
  onChange: (event: any) => void;
  onPressEnter: (event: any) => void;
  isLoading: boolean;
  hasSearched: boolean;
  onClickApplicant: (key: any) => void;
  applicantName: string;
};

const SearchApplicant: FC<Props> = ({
  applicants,
  onChange,
  onPressEnter,
  isLoading,
  hasSearched,
  onClickApplicant,
  applicantName,
}) => {
  const [prevApplicantName, setPrevApplicantName] = useState("");
  useEffect(() => {
    hasSearched &&
      isLoading &&
      applicants.length === 0 &&
      applicantName &&
      setPrevApplicantName(applicantName);
  }, [isLoading, hasSearched]);

  const handleOnPressEnter = (event: any) => {
    onPressEnter(event);
  };

  const columns = [
    {
      title: "Name",
      dataIndex: "fullName",
      key: "fullName",
      width: "320px",
      fixed: "left",
      render: (text: string, row: any): any => {
        return row.referredBy ? (
          <NameWrapper>
            <span>{text}</span>
            <StarIcon src={star} />
          </NameWrapper>
        ) : text;
      },
    },
    {
      title: "Position",
      dataIndex: "position",
      key: "position",
      width: "200px",
    },
    {
      title: "Email Address",
      dataIndex: "email",
      key: "email",
      width: "300px",
    },
    {
      title: "Recruitment Phase",
      dataIndex: "status",
      key: "status",
      width: "180px",
      render: (text: any, row: any) => {
        return (
          <ApplicantStatusContainer>
            <ApplicantStatusIn>in</ApplicantStatusIn>
            <ApplicantStatus>{text}</ApplicantStatus>
          </ApplicantStatusContainer>
        );
      },
    },
  ];

  return (
    <Wrapper>
      <InputContainer>
        <TextInput
          value={applicantName}
          onChange={onChange}
          onPressEnter={handleOnPressEnter}
          allowClear
          placeholder="Search Applicant then press enter"
        />
      </InputContainer>
      {isLoading ? (
        <LoaderContainer>
          <Loader />
        </LoaderContainer>
      ) : applicants.length !== 0 ? (
        <TableWrapper>
          <Table
            tableData={applicants}
            columns={columns as any}
            rowRecord={onClickApplicant}
          />
        </TableWrapper>
      ) : (
        <SearchPlaceholderWrapper>
          <HeaderText>
            {hasSearched
              ? `No results found for "${prevApplicantName}"`
              : `Try our applicant quick search`}
          </HeaderText>
          <QuickSearchIcon src={hasSearched ? noResults : search} />
        </SearchPlaceholderWrapper>
      )}
    </Wrapper>
  );
};

export default SearchApplicant;
